export const EMAIL_BLACK_LIST = ['rosamundj@yahoo.com'];

export const validateEmail = (value) => !EMAIL_BLACK_LIST.includes(value.trim());

export const alertBadEmail = (value) => {
  if( EMAIL_BLACK_LIST.includes(value.trim())) {
    alert('Sorry, we cannot process your request at this time. Please call us.');
    return;
  }
};